import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import auth from './auth/index';
import course from './course';
import faqs from './faqs';
import event from './event';
import catalogue from './catalogue';
import ui from './ui';
import memberships from './memberships';
import registration from './registration';
import member from './member';
import collection from './collection';
import author from './author';
import credential from './credential';
import promo from './promo';
import memberEvents from '@/modules/member/event/store';

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',

    modules: {
        auth, course, faqs, event, catalogue, ui,
        memberships, registration, collection, author,
        memberEvents, credential, promo,
        'member.wishlist': member.wishlist,
        'member.details': member.details,
        'member.latestReleases': member.latestReleases,
        'member.courses': member.courses,
        'member.assessments': member.assessments
    }
});